import { Outlet } from 'react-router-dom';
import PageContainer from '../../../../components/common/PageContainer';
import EXFTable from './Table';

const EXFPage = () => {
  return (
    <>
      <PageContainer 
        title='My Dashboard + Tasks' 
        subTitle='My Equipment Requests'
        submoduleTitle='My EXFs'  
        showDate
      >
        <EXFTable />
      </PageContainer>
      <Outlet />
    </>
  );
}

export default EXFPage;